import { App, Modal } from "antd";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  cloudAddMachine,
  cloudDeleteMachine,
  cloudUpdateStatusMachine,
  setDefaultComputerOpenAdd,
} from "store/bailiff/(default)/computer/default_computer.action";
import { defaultComputerAllSelector } from "store/bailiff/(default)/computer/default_computer.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const { confirm } = Modal;

export const useComputerRefine = () => {
  // -------------------------- VAR -----------------------------

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(defaultComputerAllSelector);
  const total = data?.length || 0;
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data, total };
};

// useComputer.
export const useComputer = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  // dialog
  const handleOpen = () => {
    dispatch(setDefaultComputerOpenAdd(true));
  };
  const handleClose = () => {
    dispatch(setDefaultComputerOpenAdd(false));
  };

  // interactive
  const handleAddMachine = (form) => {
    form
      ?.validateFields()
      ?.then((values) => {
        if (!values) return message.error("Value not found!");
        const worker = values?.worker;
        if (!worker) return message.error("Worker not found!");
        setLoading(true);
        dispatch(
          cloudAddMachine({ worker }, (res) => {
            setLoading(false);
            if (res?.status === 200) {
              message.success("Added machine succesfully!");
              handleClose();
              form?.resetFields();
            }
            if (res?.status === 500) {
              message.error(res?.data);
            }
          }),
        );
      })
      .catch((err) => console.log({ err }));
  };

  // confirm.
  const handleConfirmMachine = ({ id, key }) => {
    const content = renderLabelMachine({ key });
    confirm({
      title: content,
      centered: true,
      onOk: () => {
        processWithKey({ id, key });
      },
      onCancel: () => {},
    });
  };

  const processWithKey = ({ id, key }) => {
    if (key === "update-status") {
      return handleUpdateStatusMachine({ id });
    }
    if (key === "delete-machine") {
      return handleDeletesMachine({ id });
    }
    if (key === "force-close") {
      return handleForceCloseMachine({ id });
    }
  };

  const handleUpdateStatusMachine = ({ id }) => {
    if (!id) return message.error("Machine not found!");
    setLoading(true);
    dispatch(
      cloudUpdateStatusMachine({ id }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success("Updated machine succesfully!");
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  const handleDeletesMachine = ({ id }) => {
    if (!id) return message.error("Machine not found!");
    setLoading(true);
    dispatch(
      cloudDeleteMachine({ id }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success("Deleted machine succesfully!");
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };

  const handleForceCloseMachine = ({ id }) => {
    if (!id) return message.error("Machine not found!");
    setLoading(true);
    dispatch(
      cloudDeleteMachine({ id }, (res) => {
        setLoading(false);
        if (res?.status === 200) {
          message.success("Forced close machine succesfully!");
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return {
    loading,
    handleOpen,
    handleClose,
    handleAddMachine,
    handleConfirmMachine,
  };
};

const renderLabelMachine = ({ key }) => {
  let label = "";
  if (key === "update-status") {
    label = "Bạn có chắc là muốn cập nhật trạng thái của Machine này?";
  }
  if (key === "delete-machine") {
    label = "Bạn có chắc là muốn xoá Machine này?";
  }
  if (key === "force-close") {
    label = "Bạn có chắc là terminate Machine này?";
  }

  return label;
};
